import { http } from './http'

// 暂时不用
export const recordClickType = (data) =>
    http({
        // baseUrl: baseUrl,
        url: `/api/event/clicks`,
        method: 'post',
        alert: false,
        body: data,
    })
export const recordEventRecord = (data) =>
    http({
        // baseUrl: baseUrl,
        url: `/api/action/report`,
        method: 'post',
        alert: false,
        body: data,
    }).catch((e) => {
        console.log('recordEventRecord error', e);
    })